'use strict';

wbApp.factory('paymentsSvc', ['$resource', '$q', '$filter', 'repositorySvc', 'terminalSvc',
    function ($resource, $q, $filter, repositorySvc, terminalSvc) {
        var Payment = $resource('/Api/Payments/GetAll', {}, {            
            'update': { method: 'POST', url: '/Api/Payments/Update' },
            'insert': { method: 'POST', url: '/Api/Payments/Insert' },
            'delete': { method: 'POST', url: '/Api/Payments/Delete' },
            'issueTaxDocumentIfNeeded': { method: 'POST', url: '/Api/Payments/IssueTaxDocumentIfNeeded' },
            'getAllForUser': { method: 'GET', isArray: true, url: '/Api/Payments/GetAllForUser' },
            'insertAndBindTransaction': { method: 'POST', url: '/Api/Payments/InsertAndBindTransaction' },
            'insertAndBindOnlineTransaction': { method: 'POST', url: '/Api/Payments/InsertAndBindOnlineTransaction' },
            'getAllRelatedPaymentsByInvoiceID': { method: 'GET', isArray: true, url: '/Api/Payments/GetAllRelatedPaymentsByInvoiceID' },
            'getAmortizationScheduleDuePayments': { method: 'GET', isArray: true, url: '/Api/Payments/GetAmortizationScheduleDuePayments' },
            'getAllForSemester': { method: 'GET', isArray: true, url: '/Api/Payments/GetAllForSemester', params: {} },
            'getAllForDateRange': { method: 'GET', isArray: true, url: '/Api/Payments/GetAllForDateRange', params: {} },
           
        });

        function getAllRelatedPaymentsByInvoiceID(invoiceID) {
            return repositorySvc.customGet('getAllRelatedPaymentsByInvoiceID', Payment, {
                invoiceID: invoiceID
            });
        }

        function getAmortizationScheduleDuePayments(invoiceID) {
            return repositorySvc.customGet('getAmortizationScheduleDuePayments', Payment, {
                invoiceID: invoiceID
            });
        }

        function getAllForUserAsync(parentID) {
            return repositorySvc.customGet('getAllForUser', Payment, {
                operatorID: parentID
            });
        }

        function getAllForSemester(semesterID) {
            return repositorySvc.customGet('getAllForSemester', Payment, {
                semesterID: semesterID
            });
        }

        function getAllForDateRange(fromDate, toDate) {
            var from = moment(fromDate).startOf('day').toDate();
            var to = moment(toDate).endOf('day').toDate();

            return repositorySvc.customGet('getAllForDateRange', Payment, {
                fromDate: from,
                toDate: to
            });
        }

        function calculateSummary(payments) {
            var summary = {
                all: 0,
                paymentTypes: [
                    { name: $filter('paymentType')(0), value: 0 },
                    { name: $filter('paymentType')(1), value: 0 },
                    { name: $filter('paymentType')(2), value: 0 },
                    { name: $filter('paymentType')(3), value: 0 },
                    { name: $filter('paymentType')(4), value: 0 }
                ]
            };

            if (!payments) {
                return summary;
            }

            for (var p = 0; p < payments.length; p++) {
                var payment = payments[p];

                summary.all += payment.value;
                summary.paymentTypes[payment.paymentTypeID].value += payment.value;
            }

            return summary;
        }

        function insert(data, successCallback, errorCallback) {

            function insertImpl(terminalID) {

                data.payment.terminalID = terminalID;

                repositorySvc.insert(
                    Payment,               // $resource
                    null,                  // collection
                    data,                  // entity
                    successCallback,
                    errorCallback);
            }

            terminalSvc.getSelectedTerminalID().then(function (terminalID) {
                insertImpl(terminalID);
            }, function (err) {
                insertImpl(null);
            });

        }

        function update(data, successCallback, errorCallback) {
            function updateImpl(terminalID) {

                data.payment.terminalID = terminalID;

                repositorySvc.update(
                    Payment,               // $resource
                    null,                  // collection
                    data,                  // entity
                    successCallback,
                    errorCallback,
                    "paymentID");
            }

            terminalSvc.getSelectedTerminalID().then(function (terminalID) {
                updateImpl(terminalID);
            }, function (err) {
                updateImpl(null);
            });
        }

        function remove(data, successCallback, errorCallback) {
            repositorySvc.remove(
                Payment,               // $resource
                null,                  // collection
                data,                  // entity
                successCallback,       // successCallback
                errorCallback,
                null,
                "paymentID");
        }

        function clearPaymentEditModel(model, isAddBankPayment, isAddDuePayment, isOnlinePayment) {
            model.invoiceID = null;
            model.semesters.length = 0;
            model.semesterID = null;
            model.courses.length = 0;
            model.courseID = null;
            model.studentID = null;
            if (!isAddBankPayment && !isOnlinePayment) {
                model.amount = 0;
                var now = new Date();
                model.selectedDate = now;
            }
            model.activityID = null;
            model.activityReconciliationID = null;
            model.activities.length = 0;
            model.reconciliations.length = 0;
            model.reccurenceSchedules.length = 0;
            model.reservations.length = 0;
            model.reservationId = null;

            model.notes = "";
            model.serverError = null;
        }

        function isPaymentEditModelValid(model) {
            var commonIsValid = 
                !!model.invoiceID &&
                !!model.studentID &&
                  model.amount != 0 &&
                !!model.selectedDate;

            if (model.invoiceForType == 3) {
                return commonIsValid;                       
            }

            if (model.invoiceForType == 1 || model.invoiceForType == 2) {
                return commonIsValid && !!model.courseID;
            }

            if (model.invoiceForType == 4) {
                return commonIsValid;
            }
        }

        function initializePaymentEditModel(paymentDetail, isAddBankPayment, isAddDuePayment, isOnlinePayment) {

            var model = {
                courses: [],
                semesters: [],
                activities: [],
                reconciliations: [],
                reccurenceSchedules: [],
                reservations: []
            };

            if (!paymentDetail || !paymentDetail.paymentID) {
                model.paymentID = 0;
                model.paymentTypeID = 1;
                model.invoiceForType = 1; // 1 - regular courses, 2 - one off actions, 3 - activities, 4 - reservations
                clearPaymentEditModel(model, isAddBankPayment, isAddDuePayment, isOnlinePayment);
                if (isAddBankPayment) {
                    model.amount = paymentDetail.amount;
                    model.selectedDate = paymentDetail.selectedDate;
                    model.paymentTypeID = 0;
                }
                if (isOnlinePayment) {
                    model.amount = paymentDetail.amount;
                    model.selectedDate = paymentDetail.selectedDate;                    
                    model.paymentTypeID = 4;
                }
                if (isAddDuePayment) {
                    model.invoiceForType = paymentDetail.invoiceForType;
                    model.invoiceID = paymentDetail.invoiceID;
                }
            } else {
                model.paymentID =  paymentDetail.paymentID;
                model.paymentTypeID = paymentDetail.paymentTypeID;
                model.invoiceForType = paymentDetail.invoiceForType;
                model.selectedDate = paymentDetail.selectedDate;
                model.amount = paymentDetail.amount;
                model.invoiceID = paymentDetail.invoiceID;
                model.cashReceiptNo = paymentDetail.cashReceiptNo;
            }

            return model;
        }

        function savePaymentEditModel(model, sendNotification, successCallback, errorCallback, transactionID, accountingBookID, isOnlinePayment) {

            var dto = {
                payment: {
                    paymentID: model.paymentID,
                    paymentTypeID: model.paymentTypeID,
                    value: model.amount,
                    paymentDate: model.selectedDate,
                    invoiceID: model.invoiceID,
                    notes: model.notes,
                    typeID: model.invoiceForType,
                    // This is wrong!! typeReferenceID for Courses And Actions should contain CourseRegistrationID
                    // The same wrong code is in PaymentService.UpdateAsync
                    typeReferenceID: model.invoiceForType === 3
                        ? model.activityReconciliationID
                        : model.courseID,
                    studentID: model.studentID,                    
                    cashReceiptNo: model.paymentTypeID === 1 ? model.cashReceiptNo : null,
                    isReccuring: model.invoiceForType === 3 && !model.activityReconciliationID && !!model.invoiceID
                },
                sendNotification: sendNotification
            };

            if (!model.paymentID) {
                if (transactionID) {
                    dto.transactionID = transactionID;
                    dto.accountingBookId = accountingBookID;
                    if (isOnlinePayment) {
                        return insertAndBindOnlineTransactionAsync(dto, successCallback, errorCallback);
                    } else {
                        return insertAndBindTransactionAsync(dto, successCallback, errorCallback);
                    }
                } else {
                    return insert(dto, successCallback, errorCallback);
                }
            } else {
                return update(dto, successCallback, errorCallback);
            }
        }

        function insertAndBindOnlineTransactionAsync(data, successCallback, errorCallback) {
            return repositorySvc.customPost(
                'insertAndBindOnlineTransaction',
                Payment,
                data,
                successCallback,
                errorCallback
            )
        }

        function insertAndBindTransactionAsync(data, successCallback, errorCallback) {
            return repositorySvc.customPost(
                'insertAndBindTransaction',
                Payment,
                data,
                successCallback,
                errorCallback
            )
        }

        function issueTaxDocumentIfNeeded(paymentId, successCallback, errorCallback) {
            return repositorySvc.customPostWithParams(
                'issueTaxDocumentIfNeeded',
                Payment,
                {
                    paymentId: paymentId
                },
                {},
                successCallback,
                errorCallback,
                false
            )
        }        

        return {
            calculateSummary: calculateSummary,
            insert: insert,
            update: update,
            remove: remove,
            initializePaymentEditModel: initializePaymentEditModel,
            clearPaymentEditModel: clearPaymentEditModel,
            isPaymentEditModelValid: isPaymentEditModelValid,
            savePaymentEditModel: savePaymentEditModel,
            getAllForUserAsync: getAllForUserAsync,
            insertAndBindTransactionAsync: insertAndBindTransactionAsync,
            getAllRelatedPaymentsByInvoiceID: getAllRelatedPaymentsByInvoiceID,
            getAmortizationScheduleDuePayments: getAmortizationScheduleDuePayments,
            getAllForSemester: getAllForSemester,
            getAllForDateRange: getAllForDateRange,
            issueTaxDocumentIfNeeded: issueTaxDocumentIfNeeded
        }
    }
]);
